import { render, staticRenderFns } from "./SSODocumentationView.vue?vue&type=template&id=68029d4e&scoped=true"
import script from "./SSODocumentationView.vue?vue&type=script&lang=js"
export * from "./SSODocumentationView.vue?vue&type=script&lang=js"
import style0 from "./SSODocumentationView.vue?vue&type=style&index=0&id=68029d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68029d4e",
  null
  
)

export default component.exports